<template>
  <div class="project tc">
    <!-- <a href="/"> -->
      <!-- <img class="close-icon pointer" src="@/assets/ic-close.png" @click="goToHome()"> -->
      <!-- <h1 class="close-icon pointer f2" @click="goToHome()">HOME</h1> -->
      <h1 class="close-icon pointer f2" @click="goToHome()">Leonidas<br>Diamantis</h1>
    <!-- </a> -->
    <v-wait for="project-load">
      <template slot="waiting">
        <div class="vh-100 dt w-100 aspect-ratio--object bg-white-90">
          <div class="dtc v-mid tc white ph3 ph4-l">
            <h1 class="f6 f2-m f-subheadline-l fw6 tc black">Loading</h1>
          </div>
        </div>
      </template>
      <div class="project-details w-100 w-75-m w-80-ns w-80-l pv5">
        <!-- PROJECT TITLE -->
        <h4 class="desc-title tc">adidas China 70th Anniversary</h4>
        <!-- AGENCY INFO & YEAR -->
        <p class="agency-info">Conception / Supervision</p>
        <div class="vimeo w-75 mr-auto ml-auto">
          <vimeo-player
            ref="player"
            :video-id="videoID"
            @ready="onReady"

            :options="{ responsive: true, byline: false, portrait: false, title: false }"
            :player-height="320"
            :player-width="640"></vimeo-player>
        </div>
        <div class="project-description w-50 mv4 tc">
          <!-- PROJECT DESCRIPTION -->
          <h4>The task</h4>
          <p class="desc">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Nec feugiat in fermentum posuere urna nec tincidunt. Pulvinar sapien et ligula ullamcorper malesuada. Semper viverra nam libero justo. Arcu risus quis varius quam quisque id. Posuere morbi leo urna molestie at elementum eu.</p>
          <h4>The approach</h4>
          <p class="desc">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Nec feugiat in fermentum posuere urna nec tincidunt. Pulvinar sapien et ligula ullamcorper malesuada. Semper viverra nam libero justo. Arcu risus quis varius quam quisque id. Posuere morbi leo urna molestie at elementum eu.</p>
        </div>
        <div class="project-nav fixed tr">
          <a class="db" href="#" @click="loadProject(prevProject)">
            <h1 class="dib f2 mv0">PREVIOUS</h1>
          </a>
          <a class="db" href="#" @click="loadProject(nextProject)">
            <h1 class="dib f2 mt0">NEXT</h1>
          </a>
        </div>
      </div>
    </v-wait>
  </div>
</template>

<script>
// @ is an alias to /src
import {_} from 'vue-underscore';

export default {
  name: 'project',
  components: {
    // Item
  },
  data() {
    return {
      allProjects: [],
      currentProject: {},
      currentIndex: 0,
      videoID: '',
      playerWidth: '100%',
      height: 500,
      options: {},
      playerReady: false,
      prevProject: '',
      nextProject: ''
    }
  },
  methods: {
    goToProject(projectId) {
      this.$router.push({ name: 'project', params: { project_id: projectId } });
    },
    goToHome() {
      this.$router.push({ name: 'home' });
    },
    getImgUrl(img) {
      var images = require.context('../assets/', false, /\.(gif|jpe?g|tiff?|png|webp|bmp)$/);
      return images('./' + img);
    },
    clearCurrentProject(cb) {
      // this.currentProject       = {};
      // this.currentProjectImages = [];
      // this.clientLogo           = '';
      // this.projectTitle         = '';
      // this.campaignName         = '';
      // this.campaignType         = '';
      // this.projectDescription   = [];
      // this.projectRole          = '';
      // this.projectAgencyInfo    = '';
      // this.currentIndex         = 0;
      // this.prevProject          = '';
      // this.nextProject          = '';

      // cb();
    },
    loadProject(project_uid) {
      // var self = this;

      // this.$wait.start('project-load');

      // this.clearCurrentProject(function() {
      //   self.currentProject       = _.findWhere(self.allProjects, {uid: project_uid});
      //   self.currentIndex         = _.findIndex(self.allProjects, {uid: project_uid});

      //   self.currentProjectImages = self.currentProject.data.body[0].items;
      //   self.clientLogo           = self.currentProject.data.client_logo.url;
      //   self.projectTitle         = self.currentProject.data.project_title[0].text;
      //   self.campaignName         = self.currentProject.data.campaign_name[0].text;
      //   self.campaignType         = self.currentProject.data.campaign_type[0].text;
      //   self.projectRole          = self.currentProject.data.role[0].text;
      //   self.projectAgencyInfo    = self.currentProject.data.agency_info[0].text;

      //   for (var paragraph_index in self.currentProject.data.project_description) {
      //     if (typeof self.currentProject.data.project_description[paragraph_index].text != undefined
      //         && self.currentProject.data.project_description[paragraph_index].text != null) {
      //       self.projectDescription.push(self.currentProject.data.project_description[paragraph_index].text);
      //     }
      //   }

      //   self.nextProject = (self.currentIndex >= self.allProjects.length - 1) ? self.allProjects[0].uid : self.allProjects[self.currentIndex + 1].uid;
      //   self.prevProject = (self.currentIndex <= 0) ? self.allProjects[self.allProjects.length - 1].uid : self.allProjects[self.currentIndex - 1].uid;

      //   window.scrollTo(0, 0, 'auto');

      //   self.$wait.end('project-load');
      // });
    },
    onReady() {
      this.playerReady = true;
    },
    play () {
      this.$refs.player.play();
    },
    pause () {
      this.$refs.player.pause();
    }
  },
  created() {
    var that = this;

    this.$wait.start('project-load');

    this.$store.dispatch('fetchProjects', { vm: this, cb:
      function(results) {
        that.allProjects = results;

        that.currentProject = _.findWhere(that.allProjects, {uid: that.$route.params.project_id});
        that.currentIndex   = _.findIndex(that.allProjects, {uid: that.$route.params.project_id});

        // that.videoID = that.currentProject.data.video_id;
        that.videoID = '496859367';

        that.nextProject = (that.currentIndex >= that.allProjects.length - 1) ? that.allProjects[0].uid : that.allProjects[that.currentIndex + 1].uid;
        that.prevProject = (that.currentIndex <= 0) ? that.allProjects[that.allProjects.length - 1].uid : that.allProjects[that.currentIndex - 1].uid;

        that.$wait.end('project-load');
      }
    });
  },
  mounted() {
    var self = this;

    window.addEventListener('keyup', function(ev) {
      if (event.keyCode == 39) { //right arrow - go to next project
        self.$refs.navNextProject.click();
      }
      if (event.keyCode == 37) { //left arrow - go to previous project
        self.$refs.navPrevProject.click();
      }
    });
  }
}
</script>
<style>
  /*html,
  body {
    height: 100%;
    overflow: auto;
    margin: 0;
  }
  ::scrollbar {
    display: auto;
  }*/
</style>
<style scoped>
  a, a:visited, a:hover, a:active {color:#000;}

  .close-icon {
    position: fixed;
    left: 20px;
    /*top: 26px;*/
    /*max-width: 52px;*/
    z-index: 125;
    text-align: left;
    text-transform: uppercase;
  }
  .project {
    z-index: 125;
  }

  .project div {
    height: auto;
  }

  .project-details {
    margin: 0 auto;
  }

  .project-nav {
    height: initial;
    bottom: 0;
    right: 20px;
  }

  .project-nav img {
    max-width: 20px;
  }

  .vimeo {
    /*width: 100%;*/
    /*max-width: 75%;*/
  }

  .project-description {
    /*width: 300px;*/
    margin: 2rem auto;
  }

  .desc-title {
    font-size: 14px;
    font-weight: 700;
    font-style: normal;
    line-height: 1.2em;
    letter-spacing: 0px;
    text-transform: none;
    margin-top: 0;
  }

  .project-description p {
    padding: 0;
    font-size: 14px;
    font-weight: 400;
    font-style: normal;
    line-height: 1.5em;
    text-align: justify;
    /*text-align: center;*/
  }
</style>
